import { useEffect, useState, useRef } from "react";

import styles from "./Face2.module.scss";

export default function Face2() {
  const cardRef = useRef<HTMLDivElement>(null);

  const [fontSize, setFontSize] = useState<number | undefined>(undefined);
  const [lineHeight, setLineHeight] = useState<number | undefined>(undefined);
  const [letterSpacing, setLetterSpacing] = useState<number | undefined>(
    undefined
  );
  const [marginRight, setMarginRight] = useState<number | undefined>(undefined);

  useEffect(() => {
    // Handler to call on window resize
    function handleResize() {
      if (cardRef.current) {
        setFontSize(Math.floor(0.034 * cardRef.current.clientWidth));
        setLineHeight(0.07 * cardRef.current.clientWidth);
        setLetterSpacing(0.003 * cardRef.current.clientWidth);
        setMarginRight(-0.08 * cardRef.current.clientWidth);
      }
    }

    // Add event listener
    window.addEventListener("resize", handleResize);
    // Call handler right away so state gets updated with initial window size
    handleResize();
    // Remove event listener on cleanup
    return () => window.removeEventListener("resize", handleResize);
  }, []); // Empty array ensures that effect is only run on mount

  return (
    <div ref={cardRef} className={styles.card}>
      <div
        style={{
          fontSize: `${fontSize}px`,
          lineHeight: `${lineHeight}px`,
          marginRight: `${marginRight}px`,
          letterSpacing: `${letterSpacing}px`,
        }}
      >
        <p>Bebo, skupa smo najgori.</p>
        <p>Tuđi korak kad žuljeve nagazi</p>
        <p>Zaškićim kao mala svinja!</p>
        <p>a ti nestaješ brzinom zvuka.</p>
        <p>Nakon previše inja</p>
        <p>nitko više nema sluha.</p>
        <p>Život nas mazi jer smo zajedno</p>
        <p>(Je li to stvarno?)</p>
        <p>Nitko nas ne razumije jer namjerno</p>
        <p>volimo se lajavo, očito bezobrazno.</p>
      </div>
    </div>
  );
}
